
import { defineComponent, PropType, Ref, ref, watch } from 'vue'

// import BoardItem from './BoardItem.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import PreTripStatusIcon from '@/modules/TMSModule/components/PreTripStatusIcon/index.vue'

import { preTrip } from '@/core/types/tms-graph.types'

import getDaysBetween from './getDaysBetween'
import BoardItem from './BoardItem.vue'

const WEEKDAYS = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']

export default defineComponent({
    name: 'graph-board',
    components: { Loader, BoardItem, PreTripStatusIcon },
    props: {
        dateFrom: {
            type: String,
            default: null,
        },
        dateTo: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array as PropType<preTrip[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['open-details', 'open-transfer'],
    setup(props, { emit }) {
        const days = ref([]) as Ref<Array<string>>

        const getDay = (index: number) => {
            if (days.value.length === 0) return ''
            return days.value[index]
        }

        const getDayOfWeek = (date: string) => {
            const dayDate = new Date(date)
            return WEEKDAYS[dayDate.getDay()]
        }

        const fillDays = () => {
            if (!props.dateFrom || !props.dateTo) return
            days.value = getDaysBetween(props.dateFrom, props.dateTo)
        }

        watch(() => props.dateFrom, fillDays)
        watch(() => props.dateTo, fillDays)

        const filterByDate = (date: string) => {
            return props.items.filter((item) => item.date === date)
        }

        function formatDateToReadable(dateStr: string | null): string {
            if (!dateStr) return ''
            const [year, month, day] = dateStr.split('-').map(Number)

            const monthNames = [
                'января',
                'февраля',
                'марта',
                'апреля',
                'мая',
                'июня',
                'июля',
                'августа',
                'сентября',
                'октября',
                'ноября',
                'декабря',
            ]

            const monthName = monthNames[month - 1]

            return `${day} ${monthName} ${year}`
        }

        const onOpenDetails = (item: preTrip) => {
            emit('open-details', item)
        }

        const onOpenTransfer = (item: preTrip) => {
            emit('open-transfer', item)
        }

        return {
            days,
            getDay,
            getDayOfWeek,
            filterByDate,
            formatDateToReadable,
            onOpenDetails,
            onOpenTransfer,
        }
    },
})
